export const PATH = {
    HOME:'/procedure/person-registered-course',
    CREATE:'/procedure/person-registered-course/create/:id',
    DETAIL:'/procedure/person-registered-course/details/:id'
}